import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Divider } from '../components/Divider';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { IncludesSection } from '../components/IncludesSection';
import { PriceSection } from '../components/PriceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { OfferToast } from '../components/OfferToast';
export function Landing() {
  const scrollToPrice = useCallback(() => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <div className="w-full bg-crema font-sans text-tinta" data-id="element-235" data-mp="3tgbf7m9wisqo">
      <Header onCTA={scrollToPrice} data-id="element-236" data-mp="3tes03yzzenqh" />
      <main data-id="element-237" data-mp="3peq8kinynaox">
        <Hero onCTA={scrollToPrice} data-id="element-238" data-mp="3pegeaivvuhdf" />
        <Divider data-id="element-239" data-mp="3pfj6qv8usrvg" />
        <PainSection data-id="element-240" data-mp="3pezyk6909hum" />
        <Divider data-id="element-241" data-mp="3kfn16rkicsds" />
        <TransformationSection data-id="element-242" data-mp="3kg6kablw9mte" />
        <Divider data-id="element-243" data-mp="3kgyfhlbkxij5" />
        <WhatIsSection data-id="element-244" data-mp="3khhm45vs4khv" />
        <Divider data-id="element-245" data-mp="l0ibk80o5br1" />
        <HowItWorksSection data-id="element-246" data-mp="l11i6skvcdpr" />
        <Divider data-id="element-247" data-mp="kz89l7qp3jf4" />
        <IncludesSection data-id="element-248" data-mp="kzqestvc57z6" />
        <Divider data-id="element-249" data-mp="l2cop05p7zkk" />
        <PriceSection onCTA={scrollToPrice} data-id="element-250" data-mp="gz6fbjnahs9v" />
        <Divider data-id="element-251" data-mp="gzg8th7jmhkb" />
        <TestimonialsSection data-id="element-252" data-mp="h113r7xrs2ip" />
        <Divider className="bg-white" data-id="element-253" data-mp="c7y9syp2yr1z" />
        <GuaranteeSection data-id="element-254" data-mp="c6wtoft7jede" />
        <Divider data-id="element-255" data-mp="c63kz9aouesm" />
        <FAQSection data-id="element-256" data-mp="794t6xehyjxl" />
        <FinalCTASection onCTA={scrollToPrice} data-id="element-257" data-mp="79wqccnqsppz" />
      </main>
      <Footer data-id="element-258" data-mp="77aisd0uqa7r" />
      <OfferToast data-id="element-259" data-mp="14oirmsdwygge" />
    </div>;
}